import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import useAuth from '../../auth/useAuth';
import { generalInfoQuery, scenarioLevelsQuery, scenarioLevelsViewQuery } from './api';
import Game from './index';

export default function BalancedEquationRouter() {
  const params = useParams();
  const levelNumber = Number(params.levelNumber);

  const { getCurrentBalancedEquationGameId } = useAuth();
  const gameId = getCurrentBalancedEquationGameId();

  const { data: generalInfo, isLoading: generalInfoLoading } = useQuery(generalInfoQuery());
  const games = generalInfo?.games;
  const sessions = generalInfo?.sessions;

  const game = games?.find(g => g.game_type.includes('Balanced Equation') && g.id === gameId);
  const scenarioId = game?.scenario;

  const { data: scenarioLevels, isLoading: levelsLoading } = useQuery({
    ...scenarioLevelsQuery({ scenarioId }),
    enabled: !!scenarioId,
  });

  const { data: answerData, isLoading: answerDataLoading } = useQuery({
    ...scenarioLevelsViewQuery(scenarioId),
    enabled: !!scenarioId,
  });

  if (generalInfoLoading || !scenarioId || levelsLoading || answerDataLoading) {
    return null;
  }

  return <Game key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} scenarioId={scenarioId} answerData={answerData} games={games} gamesSessions={sessions} game={game} />;
}
